document.addEventListener('DOMContentLoaded', initSupportNkten);
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', initSupportNkten);
}

function initSupportNkten(event) {
  const root = event && event.target && event.target.querySelector
    ? event.target.querySelector('[data-support-nkten]')
    : document.querySelector('[data-support-nkten]');

  const sections = root ? [root] : document.querySelectorAll('[data-support-nkten]');

  sections.forEach((section) => {
    if (!section || section.dataset.supportInitialized) return;
    section.dataset.supportInitialized = 'true';

    initTabs(section);
    initFaqSearch(section);
  });
}

function initTabs(section) {
  const tablist = section.querySelector('[data-support-tablist]');
  if (!tablist) return;

  const tabs = Array.from(section.querySelectorAll('[data-support-tab]'));
  const panels = Array.from(section.querySelectorAll('[data-support-panel]'));

  const activate = (index, { focusTab = false } = {}) => {
    tabs.forEach((tab, i) => {
      const isActive = i === index;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    panels.forEach((panel, i) => {
      const isActive = i === index;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });

    if (focusTab && tabs[index]) tabs[index].focus();
  };

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => activate(index));

    tab.addEventListener('keydown', (e) => {
      let nextIndex = null;

      if (e.key === 'ArrowRight') {
        nextIndex = (index + 1) % tabs.length;
      } else if (e.key === 'ArrowLeft') {
        nextIndex = (index - 1 + tabs.length) % tabs.length;
      } else if (e.key === 'Home') {
        nextIndex = 0;
      } else if (e.key === 'End') {
        nextIndex = tabs.length - 1;
      }

      if (nextIndex !== null) {
        e.preventDefault();
        activate(nextIndex, { focusTab: true });
      }
    });
  });

  const panelWithMessage = section.querySelector('.support-nkten__form-message--error, .support-nkten__form-message--success');
  if (panelWithMessage) {
    const panel = panelWithMessage.closest('[data-support-panel]');
    if (panel) {
      const panelIndex = panels.indexOf(panel);
      if (panelIndex > -1) activate(panelIndex);
    }
  }
}

function initFaqSearch(section) {
  const panels = section.querySelectorAll('[data-support-panel]');

  panels.forEach((panel) => {
    const input = panel.querySelector('[data-support-faq-search]');
    const list = panel.querySelector('[data-support-faq-list]');
    if (!input || !list) return;

    const items = Array.from(list.querySelectorAll('[data-support-faq-item]'));
    const emptyState = list.querySelector('[data-support-faq-empty]');

    input.addEventListener('input', () => {
      const query = input.value.trim().toLowerCase();
      let visibleCount = 0;

      items.forEach((item) => {
        const question = (item.dataset.faqQuestion || '').toLowerCase();
        const answer = (item.dataset.faqAnswer || '').toLowerCase();
        const matches = query === '' || question.includes(query) || answer.includes(query);

        item.hidden = !matches;
        if (matches) visibleCount += 1;

        if (query !== '' && matches) {
          item.open = true;
        } else if (query === '') {
          item.open = false;
        }
      });

      if (emptyState) emptyState.hidden = visibleCount !== 0;
    });
  });
}
